import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {
  static targets = ["element"]

  static values = {
    start: { type: String, default: "top top+=100" },
    end: { type: String, default: "bottom top" },
    scale: { type: Object, default: { from: 1, to: 1 } },
    markers: { type: Boolean, default: false }
  }

  connect() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('disableParallax')) {
      this._initializeParallax()
    }
  }

  disconnect() {
    this._cleanup()
  }

  _initializeParallax() {
    this.elementTargets.forEach(element => {
      const movement = this._getElementMovement(element)

      if (this._shouldApplyScale()) {
        this._createScaleAndParallaxEffect(element, movement)
      } else {
        this._createParallaxEffect(element, movement)
      }
    })
  }

  _getElementMovement(element) {
    return {
      startX: element.dataset.startX ? parseInt(element.dataset.startX) : 0,
      endX: element.dataset.endX ? parseInt(element.dataset.endX) : 0,
      startY: element.dataset.startY ? parseInt(element.dataset.startY) : 0,
      endY: element.dataset.endY ? parseInt(element.dataset.endY) : 0
    }
  }

  _shouldApplyScale() {
    return this.hasScaleValue && (this.scaleValue.from !== 1 || this.scaleValue.to !== 1)
  }

  _createScaleAndParallaxEffect(element, { startX, endX, startY, endY }) {
    gsap.fromTo(element,
      {
        scale: this.scaleValue.from,
        x: startX,
        y: startY
      },
      {
        scale: this.scaleValue.to,
        x: endX,
        y: endY,
        ease: "none",
        scrollTrigger: this._getScrollTriggerConfig()
      }
    )
  }

  _createParallaxEffect(element, { startX, endX, startY, endY }) {
    gsap.fromTo(element,
      {
        x: startX,
        y: startY
      },
      {
        x: endX,
        y: endY,
        ease: "none",
        scrollTrigger: this._getScrollTriggerConfig()
      }
    )
  }

  _getScrollTriggerConfig() {
    return {
      trigger: this.element,
      start: this.startValue,
      end: this.endValue,
      scrub: 1,
      markers: this.markersValue
    }
  }

  _cleanup() {
    ScrollTrigger.getAll().forEach(trigger => trigger.kill())
  }
}